module.exports = __webpack_public_path__ + "static/media/skinpay.85d2b491.svg";